<script setup>
import {reactive, ref} from "vue";
import {validateNumber} from "../../store/form_validate"
import {useSystem} from "../../store/system"
import {useUser} from "../../store/user"
import {base_url} from  '../../api/baseUrl'
import {useRouter} from "vue-router";

const userStore = useUser()
const systemStore = useSystem()
const router = useRouter()

//获取所有提现记录
userStore.feedbackListApi('all')

const ruleFormRef = ref(null)
const ruleForm = reactive({
  title: '',
  content: '',
  feedback_id: '',
  image: ''
})
const rules = reactive({
  title: [
    {required: true, type: 'string', message: 'Invalid title!', trigger: 'blur'},
  ],
  content: [
    {required: true, type: 'string', message: 'Invalid content!', trigger: 'blur'},
  ]
})
const submitLoading = ref(false)
const submitForm = async (formEl) => {
  if (!formEl) return
  submitLoading.value = true
  await formEl.validate((valid, fields) => {
    if (valid) {
      userStore.setFeedback(ruleForm)
    } else {
      console.log('error submit!', fields)
    }
  })
  dialogVisible.value = false
  submitLoading.value = false
}
const resetForm = (formEl) => {
  if (!formEl) return
  formEl.resetFields()
}

const currentTab = ref('all')
const tabs = [
  {
    label: 'All',
    value: 'all',
  },
  {
    label: 'Pending',
    value: 0,
  },
  {
    label: 'Processed',
    value: 1,
  },
  {
    label: 'Closed',
    value: 2,
  },
]
const tabsChange = (val) => {
  currentTab.value = val
  userStore.feedbackPage.page = 1
  userStore.feedbackListApi(val)
}

const dialogVisible = ref(false)
const uploadImageUrl = ref('')

const handleUploadSuccess = (response, uploadFile, uploadFiles) => {
  // console.log(11111, response)
  // console.log(123123, uploadFile)
  // console.log(22222, uploadFiles)
  uploadImageUrl.value = URL.createObjectURL(uploadFile.raw)
  ruleForm.image = response.data.url
}

const showDetail = (id) => {
  router.push({path: '/Talk', query:{feedback_id: id}})
}

</script>

<template>
  <el-row>
    <el-col :span="24">
      <div class="card-bg">
        <div class="tw-p-4 tw-bottom-line tw-font-bold tw-text-[18px] tw-flex tw-justify-between tw-flex-wrap tw-items-center">
          <div>support</div>
          <div><el-button type="primary" @click="dialogVisible = true">Create Ticket</el-button></div>
        </div>
        <div class="tw-p-4">
          <div class="custom-style tw-bottom-line tw-font-bold tw-text-[18px]">
            <el-segmented
                class="!tw-flex"
                v-model="currentTab"
                :options="tabs"
                size="large"
                @change="tabsChange"
            >
              <template #default="scope">
                <div class="tw-flex tw-justify-start tw-items-center">
<!--                  <font-awesome-icon v-if="scope.item.value == 1" class="tw-text-[15px]" :icon="['fas', 'key']" />-->
<!--                  <font-awesome-icon v-if="scope.item.value != 1" class="tw-text-[15px]" :icon="['fas', 'lock']" />-->
                  <div class="tw-ml-1">{{ scope.item.label }}</div>
                </div>
              </template>
            </el-segmented>
          </div>

          <el-table
              :data="userStore.getFeedbackLog"
              class="tw-w-full tw-mt-3"
          >
            <el-table-column prop="title" label="subject"/>
            <el-table-column prop="status" label="status">
              <template #default="{row, column, $index}">
                <!--       0：待处理  1：已处理 2：已关闭）-->
                <div class="tw-inline-block tw-py-1 tw-px-2 tw-bg-orange-500 tw-rounded-md tw-text-center tw-bg-opacity-60" v-if="row.status == 0">Pending</div>
                <div class="tw-inline-block tw-py-1 tw-px-2 tw-bg-green-500 tw-rounded-md tw-text-center tw-bg-opacity-60" v-if="row.status == 1">Processed</div>
                <div class="tw-inline-block tw-py-1 tw-px-2 tw-bg-blue-500 tw-rounded-md tw-text-center tw-bg-opacity-60" v-if="row.status == 2">Closed</div>
              </template>
            </el-table-column>
            <el-table-column prop="createtime" label="Create Date">
              <template #default="{row, column, $index}">
                <div>{{systemStore.formatDate(row.createtime)}}</div>
              </template>
            </el-table-column>
            <el-table-column prop="id" label="action">
              <template #default="{row, column, $index}">
                <el-button color="#a034fa" @click="showDetail(row.id)"><el-icon :size="20"><List /></el-icon></el-button>
              </template>
            </el-table-column>
            <template #empty>
              <el-empty :image-size="120"></el-empty>
            </template>
          </el-table>

        </div>
      </div>
    </el-col>
    <el-col :span="24" class="mt-4">
      <el-pagination
          background layout="prev, pager, next"
          :page-size="parseInt(userStore.getFeedbackPage.limit)"
          :total="parseInt(userStore.getFeedbackPage.total)"
          @change="userStore.feedbackChange" />
    </el-col>
  </el-row>

  <!--    dialog modal-->
  <el-dialog class="dialog-bg xs:!tw-w-[90vw] md:!tw-w-[800px]" v-model="dialogVisible" :show-close="false" title="Shipping address">
    <template #header="{ close, titleId, titleClass }">
      <div class="my-header">
        <h4 :id="titleId" :class="titleClass" class="xs:tw-ml-[2rem] md:tw-ml-[6rem] !tw-text-[24px] tw-text-white tw-font-bold">Create New Ticket</h4>
        <button class="modal__close" type="button" @click="dialogVisible = false"><i class="ti ti-square-x"></i></button>
      </div>
    </template>

    <div class="tw-py-2 xs:tw-px-[3rem] md:tw-px-[6rem] tw-pb-5 tw-text-white tw-text-[1.2rem]">
      <el-form
          ref="ruleFormRef"
          :model="ruleForm"
          :rules="rules"
          label-width="auto"
          label-position="top"
          class="w-full"
          size="large"
          status-icon
      >

        <el-form-item label="Subject" prop="title">
          <el-input type="text" v-model="ruleForm.title" />
        </el-form-item>

        <el-form-item label="Message" prop="content">
          <el-input type="textarea" v-model="ruleForm.content" />
        </el-form-item>

        <el-form-item label="Upload Image" prop="image">
          <el-upload
              class="el-custom-uploader tw-mt-2 tw-w-full"
              :action="base_url+'/common/upload'"
              :headers="{token: userStore.getToken}"
              :data="{category: ''}"
              :show-file-list="false"
              :on-success="handleUploadSuccess"
          >
            <img v-if="uploadImageUrl" :src="uploadImageUrl" class="avatar" />
            <el-icon :size="50" v-else class="avatar-uploader-icon"><UploadFilled /></el-icon>
          </el-upload>
        </el-form-item>

        <el-form-item>
          <div class="tw-mt-[1rem] tw-flex tw-justify-end tw-w-full tw-space-x-5">
            <el-button @click="resetForm(ruleFormRef)">Clear</el-button>
            <el-button :loading="submitLoading" type="primary" @click="submitForm(ruleFormRef)">
              Submit
            </el-button>
          </div>
        </el-form-item>
      </el-form>
    </div>

    <!-- design elements -->
    <span class="screw screw--big-tl"></span>
    <span class="screw screw--big-bl"></span>
    <span class="screw screw--big-br"></span>

  </el-dialog>
</template>

<style lang="scss">
.el-form-item__label{
  color: $p-text-color !important;
}

.el-table {
  background-color: unset !important;
  color: #FFFFFF;
  border-color: $p-border-color !important;

  // 每行tr的底部线条
  td.el-table__cell, .is-leaf{
    border-bottom: 2px solid $p-border-color !important;
  }

  //解决最后一排边框线
  .el-table__inner-wrapper:before{
    background-color: unset !important;
  }

  .el-table__header-wrapper {
    tr {
      // 表头背景色
      background-color: unset;

      th {
        color: $p-text-color;
        background-color: rgba(0, 0, 0, 0);
      }
    }

  }

  .el-table__body-wrapper {
    tr {
      // 表格内容背景色
      background-color: unset;
      color: $p-text-color;

      &:hover>td {
        //修改(hover)悬浮背景色
        background-color: $p-table-row-active-color !important;
      }
    }
  }
}

.custom-style .el-segmented {
  background: $p-bg-white-linear-active-color !important;
  color: $p-text-color !important;
  //--el-segmented-item-selected-bg-color: $p-tabs-hover-bg-color;
  --el-segmented-item-selected-bg-color: rgba(255,255,255, .4);

  .el-segmented__group{
    display: flex !important;
    flex-wrap: wrap !important;

    .el-segmented__item{
      min-height: 40px;

      &:hover{
        background: $p-tabs-hover-bg-color !important;
        color: $p-text-color;
      }

    }
  }
}

@media (max-width: 639px) {
  .el-segmented__item {
    border-bottom: 2px solid $p-border-color;
  }
}
</style>
